import { AppBar, Tab, Tabs } from "@mui/material";
import './AppTabs.scss';
import React from "react";

function AppTabs({tabLabels, tabElements, tabValue, handleTabChange}) {

    interface TabPanelProps {
        children?: React.ReactNode;
        index: any;
        value: any;
      }
      
      function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <div>
                {children}
              </div>
            )}
          </div>
        );
      }
      
      function a11yProps(index: any) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }

    return (
        <div className='tabs-cntr' id="mbm_events_view__container">
            <AppBar position="static">
                 <Tabs value={tabValue} onChange={handleTabChange}>
                     {tabLabels.map((tabLabel, index) => {
                         return <Tab label={tabLabel} {...a11yProps(index)} key={index}/>
                     })}
                </Tabs>
            </AppBar>
            {tabElements.map((tabElement, index) => {
                return (
                    <TabPanel value={tabValue} index={index} key={index}>
                        <div className='tab-cntr'>
                            {tabElement}
                        </div>
                    </TabPanel>
                )
            })}
        </div>
    );
}

export default AppTabs;
